export enum Permission {
  ConnectedStoresView = 'connected_stores.view',
  CaperModify = 'caper.modify',
  CaperModifyStaging = 'caper.modify_stg',
  CaperCloudAccessModify = 'caper_cloud_access.modify',
  UposViewStatus = 'upos.view_status',
  UposConfigRetailer = 'upos.config_retailer',
  UposConfigStore = 'upos.config_store',
  ShelfLabelsModify = 'shelf_labels.modify',
  CaperTransactionsView = 'caper_transactions.view',
  CaperNotOnFileView = 'caper_not_on_file.view',
  CaperNotOnFileModify = 'caper_not_on_file.modify',
  InventoryIntelligenceView = 'inventory_intelligence.view',
  PaymentTerminalsView = 'payment_terminals.view',
  PaymentTerminalsModify = 'payment_terminals.modify',
  CaperDeviceProvisioningPipelineView = 'caper_device_provisioning_pipeline.view',
  CaperDeviceProvisioningPipelineModify = 'caper_device_provisioning_pipeline.modify',
  CaperStaffBarcodeManagementViewBarcodes = 'caper_staff_barcode_management.view_barcodes',
  CaperStaffBarcodeManagementEditBarcodes = 'caper_staff_barcode_management.edit_barcodes',
  CaperStaffBarcodeManagementViewBaBarcodes = 'caper_staff_barcode_management.view_ba_barcodes',
  CaperStaffBarcodeManagementEditBaBarcodes = 'caper_staff_barcode_management.edit_ba_barcodes',
  CaperBarcodePluMappingView = 'caper_barcode_plu_mapping.view',
  CaperBarcodePluMappingEdit = 'caper_barcode_plu_mapping.edit',
}
